export {default} from './chat-input.vue'